export default {
    VARIAVEL: 1,
    CONSTANTE: 2
}